import Select2BaseController from '../select2/base_controller'

export default class extends Select2BaseController {
  connect() {
    $(this.element).select2({
      width: 'calc(80% - 22px)',
    })

    super.connect()
  }
}
